import { render } from "./servingDeskModel.vue?vue&type=template&id=5f518da2"
import script from "./servingDeskModel.vue?vue&type=script&lang=js"
export * from "./servingDeskModel.vue?vue&type=script&lang=js"

import "./servingDeskModel.vue?vue&type=style&index=0&id=5f518da2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__